<template>
  <a-layout>
    <a-layout-content :style="{ backgroundColor: 'white' }">
      12312
    </a-layout-content>
  </a-layout>
</template>

<script>
export default {
  name: "Member",
  data() {
    return {};
  },

  created() {
    let query = this.$route.query;
    this.id = parseInt(query.id);
  },
};
</script>

<style scoped></style>
